<div *ngIf="errorData && errorData.length>0">
    <div>
      <strong *ngIf="status==='export'" class="bz-space--stack-s">{{'SYNC_FILES.EXPORT_ERROR_TABLE' | translate}}</strong>
      <strong *ngIf="status==='import'"  class="bz-space--stack-s">{{'SYNC_FILES.IMPORT_ERROR_TABLE' | translate}}</strong>
      <div>
        <table class="bz-table">
          <thead>
            <tr>
              <th class="bz-table__cell bmc-sync-data__td-left">
                {{'SYNC_FILES.ENTITY' | translate}}
              </th>
              <th class="bz-table__cell bmc-sync-data__td-left">
                {{'SYNC_FILES.IDENTITY_VALUE' | translate}}
              </th>
              <th class="bz-table__cell bmc-sync-data__td-left">
                {{'SYNC_FILES.ATTRIBUTE' | translate}}
              </th>
              <th class="bz-table__cell bmc-sync-data__td-left">
                {{'SYNC_FILES.FILE' | translate}}
              </th>
              <th class="bz-table__cell bmc-sync-data__td-left" *ngIf="!showLog" >  
                {{'SYNC_FILES.STATUS' | translate}}
              </th>
              <th class="bz-table__cell bmc-sync-data__td-left" *ngIf="showLog" >  
                {{'SYNC_FILES.ERROR_TITLE' | translate}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of errorData">
              <td class="bz-table__cell">
                {{file.EntitySource}}
              </td>
              <td class="bz-table__cell">
                {{file.IdEntityValue}}
              </td>
              <td class="bz-table__cell">
                {{file.AttributeDisplayName}}
              </td>
              <td class="bz-table__cell">
                {{file.FileName}}
              </td>
              <td class="bz-table__cell" *ngIf="!showLog" >
                <div>
                  <bzg-icon [nameIcon]="'icon-error'" [color]="'error'" [bzgTooltip]="file.Error"
                    bzgTooltipPosition="above"></bzg-icon>
                </div>
              </td>
              <td class="bz-table__cell" *ngIf="showLog">
                {{file.Error}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  